import { Message, Loading } from "element-ui"
import api from '@/api/api';
const util = {
    $error(message) {
        Message({
            showClose: false,
            message: message,
            type: 'error'
        });
    },
    $warning(message) {
        Message({
            showClose: false,
            message: message,
            type: 'warning'
        });
    },
    $success(message) {
        Message({
            showClose: false,
            message: message,
            type: 'success'
        });
    },
    getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg)){
            return unescape(arr[2]);
        }else{
            return null;
        }
    },
    setCookie(cookiename, cookievalue, hours) {
        var date = new Date();
        date.setTime(date.getTime() + Number(hours) * 3600 * 1000);
        document.cookie = cookiename + "=" + cookievalue + "; path=/;expires = " + date.toGMTString(); 
    },
    getNoticeList(params){
        return new Promise(function(reslove, reject) {
            api.getNoticeList(params).then(res=>{
                if(!res.code){
                    reslove(res.data)
                    return false
                }
                reject(res)
            });
        })
    },
    getBrandDetail(id){
        return new Promise(function(reslove, reject) {
            api.getBrandDetail({page_id:id,lang:localStorage.getItem('language') || 'zh-cn'}).then(res=>{
                if(!res.code){
                    reslove(res.data)
                    return false
                }
                reject(res)
            });
        })
    }
}
export default util


// WEBPACK FOOTER //
// ./src/utils/util.js